import { css } from '@emotion/react';

const submissionRightColumnStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export default submissionRightColumnStyles;
